import { createScopedLogger } from "@@common";
import { IBundleContext } from "../../../../UserInterfaceModule/Contexts/BundleContext";
import { DomainServiceEnumItemsExpression } from "../../../Models/DomainServices/DomainServiceEnumItemsExpression";
import { IExpressionEvaluator } from "../../../Models/IExpressionEvaluator";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";
import { MaybePromise } from "../../../Models/MaybePromise";

const logger = createScopedLogger("DomainServiceEnumItemsExpressionEvaluator");

export type BundleServices = {
  bundle: IBundleContext;
};

export const BundleServicesKey = "BundleServices";

export class DomainServiceEnumItemsExpressionEvaluator implements IExpressionEvaluator<DomainServiceEnumItemsExpression> {
  get type(): string {
    return "DomainService.EnumItems";
  }
  evaluate(expression: DomainServiceEnumItemsExpression, context: IExpressionEvaluatorContext): MaybePromise {
    const { bundle } = context.GetProperty<BundleServices>(BundleServicesKey);

    const enumModel = bundle.EnumById[expression.Enum.Id];

    if (!enumModel) {
      logger.warn("Enum not found in bundle:", expression.Enum.Id);
      return [];
    }

    //console.log(`[DomainServiceEnumItemsExpressionEvaluator] Retrieved items for Enum '${enumModel.Name}' (Id: '${enumModel.Id}'):`, enumModel.Items);
    return enumModel.Items;
  }
}
